import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/lab/Timeline": Timeline, "@mui/lab/TimelineItem": TimelineItem, "@mui/lab/TimelineSeparator": TimelineSeparator, "@mui/lab/TimelineConnector": TimelineConnector, "@mui/lab/TimelineContent": TimelineContent, "@mui/lab/TimelineDot": TimelineDot, "@mui/lab/TimelineOppositeContent": TimelineOppositeContent } } });
export default ClientProvider;
